
import React from "react";
import {
  Clock3,
  Goal,
  ShieldAlert,
  Repeat,
  CornerUpRight,
  Activity,
} from "lucide-react";

const MatchComments = ({ data }) => {

  const comments = data?.live_comments || [];
  const info = data?.info || {};

  // Event Icon
  const getEventIcon = (text) => {
    const value = text.toLowerCase();

    if (value.includes("goal")) {
      return <Goal className="w-5 h-5 text-green-600" />;
    }

    if (value.includes("yellow card")) {
      return (
        <div className="w-4 h-5 rounded-sm bg-yellow-400 border border-yellow-500" />
      );
    }

    if (value.includes("substitution")) {
      return <Repeat className="w-5 h-5 text-blue-500" />;
    }

    if (value.includes("corner")) {
      return <CornerUpRight className="w-5 h-5 text-orange-500" />;
    }

    if (value.includes("dangerous")) {
      return <ShieldAlert className="w-5 h-5 text-red-500" />;
    }

    return <Activity className="w-5 h-5 text-gray-500" />;
  };

  // Event Color
  const getEventStyle = (text) => {
    const value = text.toLowerCase();

    if (value.includes("goal")) {
      return "border-green-500 bg-green-50";
    }

    if (value.includes("yellow card")) {
      return "border-yellow-500 bg-yellow-50";
    }

    if (value.includes("dangerous")) {
      return "border-red-500 bg-red-50";
    }

    if (value.includes("substitution")) {
      return "border-blue-500 bg-blue-50";
    }

    return "border-gray-200 bg-white";
  };

  return (
     <div className="w-full rounded-3xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 shadow-sm overflow-hidden mt-4">
      {/* Header */}
      <div className="px-5 py-4 border-b border-zinc-100 dark:border-zinc-800 flex items-center justify-between">
        <div>
          <h2 className="text-lg font-bold text-zinc-900 dark:text-white">
            Match Commentary
          </h2>
          {/* <p className="text-sm text-zinc-500 dark:text-zinc-400">
            Yellow & Red Card Events
          </p> */}
        </div>
        </div>
      {/* Timeline */}
      <div className="relative border-l-2 border-gray-200 ml-4 p-4" style={{maxHeight:'500px', overflow:'auto'}} >
        {comments.map((item, index) => (
          <div
            key={index}
            className="relative pl-10 pb-6"
          >
            {/* Dot */}
            <div className="absolute -left-[14px] top-2 bg-white rounded-full p-1 border shadow-sm">
              {getEventIcon(item.text)}
            </div>

            {/* Card */}
            <div
              className={`
                rounded-2xl
                border
                p-4
                shadow-sm
                transition-all
                hover:shadow-md
                ${getEventStyle(item.text)}
              `}
            >
              {/* Top */}
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <Clock3 className="w-4 h-4" />

                  <span>{item.time}</span>
                </div>

                {item.state && (
                  <span className="text-xs bg-black text-white px-2 py-1 rounded-full">
                    {item.state}
                  </span>
                )}
              </div>

              {/* Event */}
              <h3 className="mt-2 text-base font-semibold text-gray-800">
                {item.text}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MatchComments;